import { TakeAdvanceProvider } from './TakeAdvanceContext'
import { TakeAdvanceModal } from './TakeAdvanceModal'

export const TakeAdvance = () => {
  return (
    <TakeAdvanceProvider>
      <TakeAdvanceModal />
    </TakeAdvanceProvider>
  )
}
